module.exports = __webpack_public_path__ + "img/21.fe108693.jpg";